/**
 * API停止後も既存画面のエラー処理（e.response.status / e.response.data.message を参照）を
 * そのまま使えるように、AxiosError と同じ形のエラーを生成する。
 */
export interface AppErrorResponse {
  status: number;
  data: {
    message: string;
    type: string;
  };
}

export type AppError = Error & { response: AppErrorResponse };

export const SERVICE_CLOSED_MESSAGE = 'サービス終了に伴い、この操作は現在ご利用いただけません。';
export const FETCH_FAILED_MESSAGE = 'データの取得に失敗しました。しばらくたってからもう一度お試しください。';

export const createAppError = (status: number, type: string, message: string): AppError => {
  return Object.assign(new Error(message), { response: { status, data: { message, type } } });
};

// 更新系の操作（API停止により実行できない）
export const serviceClosedError = (): AppError => createAppError(503, 'ServiceClosed', SERVICE_CLOSED_MESSAGE);

// データ未登録。既存画面は404を「未設定」として扱う
export const notFoundError = (message = 'データが見つかりません。'): AppError =>
  createAppError(404, 'NotFound', message);

// 未ログイン
export const unauthorizedError = (): AppError => createAppError(401, 'Unauthorized', 'ログインが必要です。');

// Firestoreの読み取り失敗。詳細は利用者へ返さずコンソールにのみ出す
export const fetchFailedError = (cause: unknown): AppError => {
  console.error(cause);
  return createAppError(500, 'FetchFailed', FETCH_FAILED_MESSAGE);
};

/**
 * 更新系フックの共通実装。API停止後は常に失敗させる。
 */
export const rejectServiceClosed = async (): Promise<never> => {
  throw serviceClosedError();
};
